import { useMutation, useQuery, useQueryClient, UseQueryOptions } from '@tanstack/react-query';
import {
	SavedMarketStateFilterGraphQLQueryKeys,
} from '@app/model/market_state/_saved_filters/service/SavedMarketStateFilterGraphQLQueryKeys';
import {
	SavedMarketStateFilterService,
} from '@app/model/market_state/_saved_filters/service/SavedMarketStateFilterService';
import SavedMarketStateFilter from '@app/model/market_state/_saved_filters/SavedMarketStateFilter';
import SavedMarketStateFilterFilter from '@app/model/market_state/_saved_filters/SavedMarketStateFilterFilter';

export function useFindMySavedMarketStateFilters(
	companyHotelId: number,
	options?: Omit<UseQueryOptions<SavedMarketStateFilter[], unknown, SavedMarketStateFilter[] | undefined>, 'queryKey' | 'queryFn'>,
) {
	return useQuery({
		queryFn: () => SavedMarketStateFilterService.findMySavedMarketStateFilters(companyHotelId),
		queryKey: SavedMarketStateFilterGraphQLQueryKeys.list(companyHotelId),
		...options,
	});
}

export function useCreateSavedMarketStateFilter(options?: {
	onMutate?: (variables: {
		companyHotelId: number,
		name: string,
		filter: SavedMarketStateFilterFilter,
	}) => any,
	onSuccess?: (data: SavedMarketStateFilter[]) => any,
	onError?: (error: any) => any
}) {
	const { onMutate, onSuccess, onError } = options || {};
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: SavedMarketStateFilterService.createSavedMarketStateFilter,
		onMutate: (variables) => {
			if (!!onMutate) onMutate(variables);
		},
		onSuccess: (data, variables) => {
			queryClient.setQueryData(SavedMarketStateFilterGraphQLQueryKeys.list(variables.companyHotelId), data);
			if (!!onSuccess) onSuccess(data);
		},
		onError: (error) => {
			if (!!onError) onError(error);
		},
	});
}

export function useRemoveSavedMarketStateFilter(options?: {
	onMutate?: (variables: {
		companyHotelId: number,
		id: number,
	}) => any,
	onSuccess?: (data: SavedMarketStateFilter[]) => any,
	onError?: (error: any) => any
}) {
	const { onMutate, onSuccess, onError } = options || {};
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: SavedMarketStateFilterService.removeSavedMarketStateFilter,
		onMutate: (variables) => {
			if (!!onMutate) onMutate(variables);
		},
		onSuccess: (data, variables) => {
			queryClient.setQueryData(SavedMarketStateFilterGraphQLQueryKeys.list(variables.companyHotelId), data);
			if (!!onSuccess) onSuccess(data);
		},
		onError: (error) => {
			if (!!onError) onError(error);
		},
	});
}

export function useMakeDefaultSavedMarketStateFilter(options?: {
	onMutate?: (variables: {
		companyHotelId: number,
		id: number,
	}) => any,
	onSuccess?: (data: SavedMarketStateFilter[]) => any,
	onError?: (error: any) => any
}) {
	const { onMutate, onSuccess, onError } = options || {};
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: SavedMarketStateFilterService.makeDefaultSavedMarketStateFilter,
		onMutate: (variables) => {
			if (!!onMutate) onMutate(variables);
		},
		onSuccess: (data, variables) => {
			queryClient.setQueryData(SavedMarketStateFilterGraphQLQueryKeys.list(variables.companyHotelId), data);
			if (!!onSuccess) onSuccess(data);
		},
		onError: (error) => {
			if (!!onError) onError(error);
		},
	});
}